<a uiSref="{{srefState}}" [uiParams]="{locationId: locationId, locationGroupId: result.Id}" class="list-group-item list-group-item-action no-border">
    <span>
        {{result.LocationGroupLabel}}<strong>{{result.LocationSubGroupName}}</strong>
    </span>
</a>
